import type { ReactNode } from "react";

import { Backdrop } from "@/components/modals/Backdrop";
import { Icon } from "./Icon";
import "./Modal.css";

type Props = {
  onClose: () => void;
  title?: ReactNode;
  subtitle?: ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
  align?: "center" | "top";
  footer?: ReactNode;
  children: ReactNode;
};

const SIZE_CLASS = { sm: "ui-modal-sm", md: "ui-modal-md", lg: "ui-modal-lg", xl: "ui-modal-xl" };

export function Modal({ onClose, title, subtitle, size = "md", align = "center", footer, children }: Props) {
  return (
    <Backdrop onClose={onClose} align={align}>
      <div className={`ui-modal ${SIZE_CLASS[size]}`}>
        {(title || subtitle) && (
          <header className="ui-modal-head">
            <div>
              {title && <h2 className="ui-modal-title">{title}</h2>}
              {subtitle && <p className="ui-modal-sub">{subtitle}</p>}
            </div>
            <button className="ui-modal-close" onClick={onClose} aria-label="Fechar">
              <Icon name="x" size={16} />
            </button>
          </header>
        )}
        <div className="ui-modal-body">{children}</div>
        {footer && <footer className="ui-modal-foot">{footer}</footer>}
      </div>
    </Backdrop>
  );
}
